import { Textarea, TextareaProps } from '@mantine/core'
import React from 'react'

export function ETextArea(props: TextareaProps) {
  return (
    <Textarea
      label={props.label}
      styles={{
        input: {
          borderRadius: '8px',
          fontSize: '17px',
        },
        label: {
          marginBottom: '2px',
          fontWeight: 400,
          fontSize: '15px',
          color: '#374151',
        },
        error: {
          fontSize: '12px',
          marginTop: '4px',
        },
        ...props.styles as any,
      }}
      size={props.size}
      className={props.className}
      minRows={props.minRows}
      maxRows={props.maxRows}
      rows={props.rows}
      description={props.description}
      value={props.value}
      placeholder={props.placeholder}
      error={props.error}
      onChange={props.onChange}
    />
  )
}
